import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
import * as commonStyles from '../../components/common.style';
var global = variables.global;
export var container = /*#__PURE__*/css(".slick-slider{margin-left:-55%;}", media('>=tablet'), "{max-width:", global.pageBodyWidth, ";margin:0 auto;}");
export var title = commonStyles.mainTitle;